import { AuthLayout } from '@/layouts/AuthLayout';
import { useLoginMutation } from '@/features/auth/authApi';
import { LoginForm } from './LoginForm';

export function LoginPage() {
  const [login, { isLoading, error, reset }] = useLoginMutation();

  return (
    <AuthLayout
      title="Sign in to your Tixbase account"
      description="Use the email address your invitation was sent to."
    >
      <title>Sign in · Tixbase</title>

      <LoginForm
        submitting={isLoading}
        error={error}
        onEdit={reset}
        onSubmit={login}
      />

      <p className="text-body-xs text-muted-foreground">
        Access to Tixbase is by invitation only. Ask your administrator for an invite.
      </p>
    </AuthLayout>
  );
}
